import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import {
  canAssignPositionSlot,
  canCreatePositionFillRequest,
  canEditPositionSlot,
  canFreezePositionSlot,
  canRetirePositionSlot,
  canUnfreezePositionSlot,
} from 'domain/shared/positionSlot';
import type { ObjectDetailsHeaderAction } from 'framework/ViewTypes/contentLayout';
import type { PreviewPositionSlotListItem } from '../../types';

export type PositionSlotHeaderCallbacks = {
  onEdit: () => void;
  onAssign: () => void;
  onCreatePositionFillRequest: () => void;
  onFreeze: () => void;
  onUnfreeze: () => void;
  onRetire: () => void;
};

export type PositionSlotHeaderPermissions = {
  canUpdate: boolean;
  canAssign: boolean;
  canCreatePositionFillRequest: boolean;
  canFreeze: boolean;
  canUnfreeze: boolean;
  canRetire: boolean;
  canCreateTimelineEntry: boolean;
};

export const getPositionSlotHeaderActions = (
  positionSlot: PreviewPositionSlotListItem,
  callbacks: PositionSlotHeaderCallbacks,
  permissions: PositionSlotHeaderPermissions,
): ObjectDetailsHeaderAction[] => {
  const actions: ObjectDetailsHeaderAction[] = [];

  if (permissions.canUpdate && canEditPositionSlot(positionSlot)) {
    actions.push({
      id: 'edit-position',
      label: 'Edit position',
      icon: <EditOutlinedIcon />,
      tooltip: 'Edit position',
      variant: 'outlined',
      onClick: callbacks.onEdit,
    });
  }
  if (permissions.canAssign && canAssignPositionSlot(positionSlot)) {
    actions.push({
      id: 'assign-worker',
      label: 'Assign worker',
      icon: <PersonOutlineOutlinedIcon />,
      tooltip: 'Assign worker',
      variant: 'outlined',
      onClick: callbacks.onAssign,
    });
  }
  if (permissions.canCreatePositionFillRequest && canCreatePositionFillRequest(positionSlot)) {
    actions.push({
      id: 'create-position-fill-request',
      label: 'Create position fill request',
      icon: <SendOutlinedIcon />,
      tooltip: 'Create position fill request',
      variant: 'outlined',
      onClick: callbacks.onCreatePositionFillRequest,
    });
  }
  if (permissions.canFreeze && canFreezePositionSlot(positionSlot)) {
    actions.push({
      id: 'freeze-position',
      label: 'Freeze position',
      icon: <AcUnitIcon />,
      tooltip: 'Freeze position',
      variant: 'outlined',
      onClick: callbacks.onFreeze,
    });
  }
  if (permissions.canUnfreeze && canUnfreezePositionSlot(positionSlot)) {
    actions.push({
      id: 'unfreeze-position',
      label: 'Unfreeze position',
      icon: <PlayArrowIcon />,
      tooltip: 'Unfreeze position',
      variant: 'outlined',
      onClick: callbacks.onUnfreeze,
    });
  }
  if (permissions.canRetire && canRetirePositionSlot(positionSlot)) {
    actions.push({
      id: 'retire-position',
      label: 'Retire position',
      icon: <ArchiveOutlinedIcon />,
      tooltip: 'Retire position',
      variant: 'outlined',
      onClick: callbacks.onRetire,
    });
  }

  return actions;
};
